import { render, staticRenderFns } from "./OddJob.vue?vue&type=template&id=7d1b8b07&scoped=true"
import script from "./OddJob.vue?vue&type=script&lang=js"
export * from "./OddJob.vue?vue&type=script&lang=js"
import style0 from "../../utils/commen.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./OddJob.vue?vue&type=style&index=1&id=7d1b8b07&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d1b8b07",
  null
  
)

export default component.exports